// extracted by mini-css-extract-plugin
export var aboveInput = "_f7-0";
export var actionButton = "_f7-5";
export var actionButtonContainer = "_f7-1";
export var actionIcon = "_f7-6";
export var aiInfoContainer = "_f7-2";
export var attachmentWrapper = "_f7-7";
export var bold = "_f7-3";
export var checkIcon = "_f7-8";
export var clickingRecipientBar = "_f7-11";
export var commentThreadSwitch = "_f7-a";
export var draftImage = "_f7-b";
export var draftImageContainer = "_f7-c";
export var draftImages = "_f7-e";
export var editButton = "_f7-g";
export var editor = "_f7-f";
export var editorContainer = "_f7-y";
export var editorErrorTooltipWrapper = "_f7-9";
export var headerDivider = "_f7-h";
export var icon = "_f7-i";
export var info = "_f7-j";
export var internal = "_f7-n";
export var internalDivider = "_f7-k";
export var internalMessage = "_f7-l";
export var messageInputCard = "_f7-m";
export var messageInputForm = "_f7-o";
export var messageInputFormInternal = "_f7-p";
export var options = "_f7-q";
export var publicMessageCustomer = "_f7-s";
export var publicMessageMerchant = "_f7-r";
export var removeImageButton = "_f7-d";
export var replyButtons = "_f7-t";
export var showSignatureButton = "_f7-u";
export var spinner = "_f7-v";
export var verticalButtonDivider = "_f7-4";
export var visibilitySelector = "_f7-w";
export var warning = "_f7-x";
export var wrappingText = "_f7-z";
export var writingInternalNoteTopBorder = "_f7-10";